  import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DisabilityDeclarationDto, EmployeeBioDataDto } from 'src/app/models/documentationForNewHire';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ActivatedRoute } from '@angular/router';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';
import { DocumentModel, DocumentUploadDto } from 'src/app/models/requests/DocumentUploadDto';
import { UploadedEmployeeInfo } from 'src/app/models/uploaded-employee';

@Component({
  selector: 'app-documentation-new-hire',
  templateUrl: './documentation-new-hire.component.html',
  styleUrls: ['./documentation-new-hire.component.css']
})
export class DocumentationNewHireComponent {
  payrollForm: FormGroup;
  hmoForm: FormGroup;
  dataConsentForm: FormGroup;
  backgroundForm: FormGroup;
  groupLifeForm: FormGroup;
  disabilityForm: FormGroup;
  router: any;
  currentStep = 1;
  passportPreview: string | ArrayBuffer | null = null;
  policyConfirmed = false;
  today: Date = new Date();
  name: string = '' 
  token: string = '';
  // backgroundConfirmed:boolean = false;
  documentList: DocumentModel[]=[];

  constructor(private fb: FormBuilder,private route: ActivatedRoute,private manpowerservice:ManpowerrecruitmentService) {
    this.payrollForm = this.fb.group({
      firstName: ['', Validators.required],
      otherNames: ['', Validators.required],
      surnameAtBirth: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      title: ['', Validators.required],
      gender: ['', Validators.required],
      designation: ['', Validators.required],
      resumptionDate: ['', Validators.required],
      maritalStatus: ['', Validators.required],
      nationality: ['', Validators.required],
      address: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      bank: ['', Validators.required],
      accountNumber: ['', Validators.required],
      nextOfKin: ['', Validators.required],

      education: this.fb.array([ this.createEducation() ], Validators.required),
      languageSpoken: ['', Validators.required],
      languageWritten: ['', Validators.required],
      family: this.fb.array([ this.createFamilyMember() ], Validators.required),
      experience: this.fb.array([ this.createExperience() ], Validators.required)
    });

    this.hmoForm = this.fb.group({
      surname: ['', Validators.required],
      otherNames: ['', Validators.required],
      dob: ['', Validators.required],
      gender: ['', Validators.required],
      hospital: ['', Validators.required],
      bloodGroup: ['', Validators.required],
      genotype: ['', Validators.required]
    });

    this.dataConsentForm = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', Validators.required, Validators.email],
      date: ['', Validators.required]
    });

    this.backgroundForm = this.fb.group({
      surname: ['', Validators.required],
      otherNames: ['', Validators.required],
      dob: ['', Validators.required],
      address: ['', Validators.required],
      matricNo: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      ref1: ['', Validators.required],
      ref2: ['', Validators.required],
      witness: ['', Validators.required],
      consent: [false, Validators.requiredTrue]
    });

    this.groupLifeForm = this.fb.group({
      fullName: ['', Validators.required],
      address: ['', Validators.required],
      beneficiaries: this.fb.array([this.createBeneficiary()]),
      guardianName: [''],
      guardianAddress: [''],
      guardianPhone: [''],
      nextOfKin: ['', Validators.required],
      emergencyContact: ['', Validators.required],
      date: ['', Validators.required],
      signedBy: ['', Validators.required],
      witnessName: ['', Validators.required],
      witnessSignature: ['', Validators.required]
    });


    this.disabilityForm = this.fb.group({
      hasDisability: [null, Validators.required],   // yes | no | na
      conditionDetails: [''],
      pastAdjustments: [''],
      names: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      date: ['', Validators.required],
      signature: ['', Validators.required]
    }, { updateOn: 'change' });
  }

  ngOnInit(): void{
    debugger
    // 🔑 1. Capture token from query string (if present)
  this.route.queryParamMap.subscribe(params => {
    const token = params.get('to');
    if (token) {
      localStorage.setItem('onboardingToken', token);  // save for later
      this.token = token; // keep in component too
    } else {
      // fallback: try localStorage if query param missing
      this.token = localStorage.getItem('onboardingToken') || '';
    }
  });
    // localStorage.removeItem('currentStep');
    let currentStep = localStorage.getItem('currentStep');
    if(currentStep){
      this.currentStep = Number(currentStep)
      this.loadFormData('payrollForm', this.payrollForm);
      this.policyConfirmed = localStorage.getItem('policyConfirmed')? true : false;
      this.loadFormData('dataConsentForm', this.dataConsentForm);
      this.loadFormData('backgroundForm', this.backgroundForm);
      this.loadFormData('disabilityForm', this.disabilityForm);
    }
  }
  nextStep() {
    this.persistCurrentStep();
    this.currentStep++;
    localStorage.setItem('currentStep', this.currentStep.toString());
  }

  prevStep() {
    this.persistCurrentStep();
    this.currentStep--;
    localStorage.setItem('currentStep', this.currentStep.toString());
  }

  saveFormData(key: string, form: FormGroup) {
    localStorage.setItem(key, JSON.stringify(form.value));
  }

  loadFormData(key: string, form: FormGroup) {
    const data = localStorage.getItem(key);
    if (data) {
      form.patchValue(JSON.parse(data));
    }
  }

  clearAllFormData() {
    localStorage.removeItem('payrollForm');
    localStorage.removeItem('dataConsentForm');
    localStorage.removeItem('backgroundForm');
    localStorage.removeItem('disabilityForm');
  }

  persistCurrentStep() {
    switch (this.currentStep) {
      case 3: this.saveFormData('payrollForm', this.payrollForm); break;
      case 2: localStorage.setItem('policyConfirmed', 'true'); break;
      case 4: this.saveFormData('backgroundForm', this.backgroundForm); break;
      case 5: this.saveFormData('disabilityForm', this.disabilityForm); break;
      // case 3: this.saveFormData('hmoForm', this.hmoForm); break;
      // case 4: this.saveFormData('dataConsentForm', this.dataConsentForm); break;
    }
  }

   createEducation(): FormGroup {
    return this.fb.group({
      degree: ['', Validators.required],
      country: ['', Validators.required],
      school: ['', Validators.required]
    });
  }

  createFamilyMember(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      relationship: ['', Validators.required],
      dob: ['', Validators.required]
    });
  }

  createExperience(): FormGroup {
    return this.fb.group({
      company: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      jobTitle: ['', Validators.required]
    });
  }

  get beneficiaries(): FormArray {
  return this.groupLifeForm.get('beneficiaries') as FormArray;
}

createBeneficiary(): FormGroup {
    return this.fb.group({
      name: [''],
      address: [''],
      relationship: [''],
      share: ['']
    });
  }

  addBeneficiary(): void {
    this.beneficiaries.push(this.createBeneficiary());
  }

  removeBeneficiary(index: number): void {
    this.beneficiaries.removeAt(index);
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.passportPreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  savePayroll() {
     this.payrollForm.markAllAsTouched();

    if (this.payrollForm.invalid) {
      return; // do not proceed
    }
    console.log(this.payrollForm.value);
    let firstName = this.payrollForm.get('firstName')?.value || '';
    let otherName = this.payrollForm.get('otherNames')?.value || '';
    let surname = this.payrollForm.get('surnameAtBirth')?.value || '';
    this.name = `${surname}, ${firstName} ${otherName}`
    this.nextStep();
  }

  get education() { return this.payrollForm.get('education') as FormArray; }
  get family() { return this.payrollForm.get('family') as FormArray; }
  get experience() { return this.payrollForm.get('experience') as FormArray; }

 addEducation() {
    this.education.push(this.createEducation());
  }

  addFamily() {
    this.family.push(this.createFamilyMember());
  }

  addExperience() {
    this.experience.push(this.createExperience());
  }


  saveHmo() { this.hmoForm.markAllAsTouched(); if (this.hmoForm.valid) { console.log(this.hmoForm.value); this.nextStep(); } }
  saveDataConsent() { this.dataConsentForm.markAllAsTouched(); if (this.dataConsentForm.valid) { console.log(this.dataConsentForm.value); this.nextStep(); } }
  saveBackground() { this.backgroundForm.markAllAsTouched(); if (this.backgroundForm.valid) { console.log(this.backgroundForm.value); this.nextStep(); } }
  saveGroupLife() {
    this.groupLifeForm.markAllAsTouched();
    if (!this.validateBeneficiaries()) { return; }
    if (this.groupLifeForm.valid) {
      console.log(this.groupLifeForm.value);
      this.nextStep();
    }
  }
   // ensure each beneficiary entry is filled (no empty required fields)
    validateBeneficiaries(): boolean {
      const arr = this.beneficiaries.controls;
      if (!arr || arr.length === 0) { return false; }
      for (const c of arr) {
        if (c.invalid) { return false; }
        // optionally ensure share is numeric and >=0
        const share = c.get('share')?.value;
        if (share === null || share === undefined || share === '') { return false; }
      }
      return true;
    }
   saveDisability() {
      this.disabilityForm.markAllAsTouched();
      if (this.disabilityForm.valid) {
        console.log(this.disabilityForm.value);
        // do not navigate here — submitAll() will advance to step 7 when complete
      }
    }

     // ---------- PDF capture & upload ----------
  // capture a section by DOM id, convert to PDF blob and return the blob
  async captureSectionPdf(sectionId: string, fileName: string): Promise<Blob> {
    const el = document.getElementById(sectionId);
    if (!el) {
      throw new Error(`Section ${sectionId} not found`);
    }

    // make sure the element is visible (if hidden by *ngIf, it should be visible during capture)
    // html2canvas captures the DOM node
    const canvas = await html2canvas(el, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    // create a fairly-sized PDF page (A4)
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // fit the image into page while preserving aspect ratio
    const img = new Image();
    img.src = imgData;
    await new Promise<void>((res) => { img.onload = () => res(); });

    const imgProps = { width: img.width, height: img.height };
    const ratio = Math.min(pageWidth / imgProps.width, pageHeight / imgProps.height);
    const imgWidth = imgProps.width * ratio;
    const imgHeight = imgProps.height * ratio;
    const marginX = (pageWidth - imgWidth) / 2;

    pdf.addImage(imgData, 'PNG', marginX, 20, imgWidth, imgHeight);
    // convert to blob
    const blob = pdf.output('blob');
    return blob;
  }

  private async blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob); // returns "data:application/pdf;base64,JVBERi0xLjc..."
  });
}


  // send a blob to backend as multipart/form-data with filename and metadata
  async uploadPdfBlob(blob: Blob, filename: string): Promise<any> {
    debugger
    const formData = new FormData();
    formData.append('file', blob, filename);
    // include some metadata about the form if needed
    formData.append('uploader', this.name || 'unknown');
    formData.append('uploadedAt', new Date().toISOString());

    // make the POST — change to match your backend
    // return this.http.post(this.uploadUrl, formData).toPromise();
  }

  // captures sections 2..6 sequentially and uploads; on success moves to step 7
  /*
  async submitAll(): Promise<void> {
    debugger
    try {
      // ensure final form is valid before attempting capture
      this.saveDisability();
      if (this.disabilityForm.invalid) {
        // user must fix errors
        return;
      }

      // sequence: payroll (2), policy (3), background (4), group-life (5), disability (6)
      const sections = [
        { id: 'section-payroll', filename: `payroll_${this.name || 'user'}.pdf` },
        { id: 'section-policy', filename: `policy_${this.name || 'user'}.pdf` },
        { id: 'section-background', filename: `background_${this.name || 'user'}.pdf` },
        { id: 'section-group-life', filename: `grouplife_${this.name || 'user'}.pdf` },
        { id: 'section-disability', filename: `disability_${this.name || 'user'}.pdf` }
      ];

      // show a quick client-side validation for forms
      if (this.payrollForm.invalid || !this.policyConfirmed || this.backgroundForm.invalid ||  this.groupLifeForm.invalid || this.disabilityForm.invalid) {
        // mark all as touched to show errors
        this.payrollForm.markAllAsTouched();
        this.backgroundForm.markAllAsTouched();
        this.groupLifeForm.markAllAsTouched();
        this.disabilityForm.markAllAsTouched();
        // do not proceed
        return;
      }

      // Ensure each target section is visible before capture. If they are hidden with *ngIf,
      // Temporarily show them by toggling currentStep so their DOM nodes exist.
      // We'll capture each section by temporarily setting currentStep then capturing it.
      for (const sec of sections) {
        // make the section visible
        const savedStep = this.currentStep;
        // determine which step contains this section (map by id)
        // mapping used: section-payroll -> 2, section-policy -> 3, section-background -> 4, section-group-life ->5, section-disability -> 6
        let stepForId = 2;
        if (sec.id === 'section-policy') stepForId = 3;
        if (sec.id === 'section-background') stepForId = 4;
        if (sec.id === 'section-group-life') stepForId = 5;
        if (sec.id === 'section-disability') stepForId = 6;
        this.currentStep = stepForId;

        // allow change detection to render — small delay may be necessary in real app
        // but we will await html2canvas which requires DOM to be rendered.
        await new Promise(resolve => setTimeout(resolve, 200));

        // capture
        const blob = await this.captureSectionPdf(sec.id, sec.filename);
        // upload
        debugger
        await this.uploadPdfBlob(blob, sec.filename);

        // restore previous step (or keep at savedStep)
        this.currentStep = savedStep;
      }

      // All uploads succeeded — move to final confirmation step
      this.currentStep = 7;
      localStorage.setItem('currentStep', this.currentStep.toString());
    } catch (err) {
      console.error('SubmitAll error', err);
      // optionally show a user-facing error message here
    }
  }
  */
 async submitAll(): Promise<void> {
  try {
    debugger
    // this.saveDisability();
    // if (this.disabilityForm.invalid) return;

    if (
      this.payrollForm.invalid ||
      !this.policyConfirmed ||
      this.backgroundForm.invalid ||
      this.disabilityForm.invalid
    ) {
      this.payrollForm.markAllAsTouched();
      this.backgroundForm.markAllAsTouched();
      this.disabilityForm.markAllAsTouched();
      return;
    }

    const sections = [
      { id: 'section-payroll', filename: `payroll_${this.name || 'user'}.pdf` },
      { id: 'section-policy', filename: `policy_${this.name || 'user'}.pdf` },
      { id: 'section-background', filename: `background_${this.name || 'user'}.pdf` },
      { id: 'section-disability', filename: `disability_${this.name || 'user'}.pdf` }
    ];

    const formData = new FormData();
    formData.append('Token', this.token); // ✅ attach token

    for (const sec of sections) {
      const savedStep = this.currentStep;

      let stepForId = 2;
      if (sec.id === 'section-payroll') stepForId = 3;
      if (sec.id === 'section-policy') stepForId = 2;
      if (sec.id === 'section-background') stepForId = 4;
      if (sec.id === 'section-disability') stepForId = 5;

      this.currentStep = stepForId;
      await new Promise(resolve => setTimeout(resolve, 200));

      const blob = await this.captureSectionPdf(sec.id, sec.filename);
      
      // Convert blob to Base64 string
      const base64String = await this.blobToBase64(blob);
      // formData.append('UploadFiles', blob, sec.filename);
       const doc: DocumentModel = {
        documentName: sec.filename,
        documentDescription: sec.id, // or any description
        documentContent: base64String,
        contentType: "application/pdf"
      };
      this.documentList.push(doc);
      this.currentStep = savedStep;
    }
    debugger
    // 🔥 Call your service here
     const request : DocumentUploadDto = {
      documentList : this.documentList,
      token : this.token
     }
     this.manpowerservice.NewHireSubmitResponse(request).subscribe({
      next: () => {
        this.currentStep = 7;
        localStorage.setItem('currentStep', this.currentStep.toString());

      },
      error: () => {
        //error message 
        console.error('SubmitAll error');

      } 
  });

  } catch (err) {
    console.error('SubmitAll error', err);
  }
}

  //for testing
  async submitAllLocal(): Promise<void> {
  try {
    const sections = [
      { id: 'section-payroll', filename: `payroll_${this.name || 'user'}.pdf`, step: 2 },
      { id: 'section-policy', filename: `policy_${this.name || 'user'}.pdf`, step: 3 },
      { id: 'section-background', filename: `background_${this.name || 'user'}.pdf`, step: 4 },
      { id: 'section-group-life', filename: `grouplife_${this.name || 'user'}.pdf`, step: 5 },
      { id: 'section-disability', filename: `disability_${this.name || 'user'}.pdf`, step: 6 }
    ];

    for (const sec of sections) {
      const savedStep = this.currentStep;
      this.currentStep = sec.step;

      // allow Angular to render
      await new Promise(resolve => setTimeout(resolve, 200));

      // capture the PDF
      const blob = await this.captureSectionPdf(sec.id, sec.filename);

      // trigger browser download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = sec.filename;
      a.click();
      window.URL.revokeObjectURL(url);

      this.currentStep = savedStep;
    }

    // move to confirmation step (optional)
    this.currentStep = 7;
    localStorage.setItem('currentStep', this.currentStep.toString());
  } catch (err) {
    console.error('submitAllLocal error', err);
  }
}

}
